import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import api from '@/helpers/fetch'
import AWS from 'aws-sdk'
import Control from '@/helpers/control'

library.add(faTrashAlt)

const bucketName = 'portal-profile-image'
const bucketRegion = 'sa-east-1'
const IdentityPoolId = 'sa-east-1:bc7f9ff6-d461-4870-b480-29756e9502e9'
let s3 = null as any

@Component({
	components: {
		Loader,
	},
})
export default class CreateUser extends Vue {
	form = {
		name: '',
		email: '',
		file: [] as Array<File>,
		password: '',
		passwordRepeat: '',
		imageUrl: '',
		block_date: null,
		phone_number: '',
	}

	errorMsg = ''

	loading = false
	saving = false
	deletingImage = false
	savingImage = false
	control = new Control()

	async loadUser() {
		const res = await api.get('/api/my-account/profile')
		if (res.ok) {
			Object.assign(this.form, res.data)
		}
	}

	successToast() {
		this.$bvToast.toast('Dados Atualizados!', {
			title: 'Sucesso!',
			variant: 'success',
			solid: true,
			toaster: 'b-toaster-top-center',
		})
	}

	errorToast() {
		this.$bvToast.toast(
			'Tivemos um erro, entre em contato com a area de T.I.',
			{
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			},
		)
	}

	awsSetup() {
		AWS.config.update({
			region: bucketRegion,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: IdentityPoolId,
			}),
		})

		s3 = new AWS.S3({
			apiVersion: '2006-03-01',
			params: { Bucket: bucketName },
		})
	}

	uploadImage(callback) {
		if (!(this.form.file instanceof File)) {
			return
		}

		// userid_timestamp-randomString_originalFilename
		const fileName =
			this.$route.params.userId +
			'_' +
			Date.now() +
			'-' +
			Math.round(Math.random() * 1e5) +
			'_' +
			this.form.file.name

		s3.upload(
			{
				Bucket: bucketName,
				Key: fileName,
				Body: this.form.file,
				ContentType: this.form.file.type,
			},
			(err, data) => {
				/**
				 * data: {
				 *   Bucket, (bucket name)
				 *   ETag, (random string)
				 *   Key, (filename)
				 *   Location, (full url)
				 *   key, (filename)
				 * }
				 */
				if (err) {
					this.errorToast()
				} else {
					callback(data.Location)
				}
			},
		)
	}

	onInput(name, value) {
		const debouncedChange = this.control.debounce(() => {
			this.save(name, value)
		}, 1000)
		debouncedChange()
	}

	async save(name, value) {
		const update = {}
		update[name] = value
		this.saving = true
		const res = await api.post('/api/my-account/profile', update)
		this.saving = false

		if (res.ok) {
			this.successToast()
		} else {
			this.errorToast()
		}
	}

	async saveImage() {
		this.savingImage = true
		this.uploadImage(async (imageUrl) => {
			const res = await api.post('/api/my-account/profile', { imageUrl })
			if (res.ok) {
				this.form.imageUrl = imageUrl
				this.successToast()
			} else {
				this.errorToast()
			}
			this.savingImage = false
		})
	}

	async deleteImage() {
		this.deletingImage = true
		const res = await api.post('/api/users/' + this.$route.params.userId, {
			imageUrl: '',
		})
		if (res.ok) {
			this.form.imageUrl = ''
			this.successToast()
		} else {
			this.errorToast()
		}
		this.deletingImage = false
	}

	async submitPassword() {
		if (this.form.password === '') {
			this.errorMsg = 'Por favor, preencha uma senha'
			return
		}

		if (this.form.password !== this.form.passwordRepeat) {
			this.errorMsg = 'As senhas não coincidem'
			return
		}

		this.loading = true
		const res = await api.post('/api/my-account/profile/password', {
			password: this.form.password,
		})
		this.loading = false

		if (res.ok) {
			this.successToast()
			this.form.password = ''
			this.form.passwordRepeat = ''
		} else {
			this.errorToast()
		}
	}

	async mounted() {
		this.loading = true
		await this.loadUser()
		this.loading = false
		this.awsSetup()
	}

	beforeDestroy() {
		s3 = null
	}
}
